module.exports = __webpack_public_path__ + "img/shareUserCollection_bg.6240750e.png";